export default (value: string) => {
  if (value) {
    return value.toLowerCase().replace(/(?:^|\s)\S/g, letter => letter.toUpperCase())
  }
}
